export default __webpack_public_path__ + "static/media/loader.46bb6e43.svg";